// @ts-ignore
import { PartySocket } from 'https://js13kgames.com/2025/online/partysocket.js'

export const useHead = () => {
  window.PartySocket = PartySocket
}
